import { HttpErrorResponse, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injector } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AccessFacade } from '../../access';
import { AppStateFacade } from '../../app-state';
import { AppMessage, AppMessageFactory } from '../../messages';
import { ErrorHandlerService } from '../error-handler/error-handler.service';
import * as i0 from "@angular/core";
import * as i1 from "../../messages";
import * as i2 from "../error-handler/error-handler.service";
export let ApiErrorInterceptor = /*#__PURE__*/(() => {
  class ApiErrorInterceptor {
    constructor(messageFactory, errorHandler, injector) {
      this.messageFactory = messageFactory;
      this.errorHandler = errorHandler;
      this.injector = injector;
    }
    intercept(request, next) {
      // return next.handle(request);
      return next.handle(request).pipe(catchError(err => {
        this.errorHandler.handleError(err);
        if (err.status === 0) {
          this.injector.get(AccessFacade).suppressIsReady();
          this.injector.get(AppStateFacade).setConnectionError(true);
          return throwError(() => err);
        } else {
          if (err instanceof AppMessage) return throwError(() => err);
          const error = this.messageFactory.create(err);
          return throwError(() => error);
        }
      }));
    }
    static {
      this.ɵfac = function ApiErrorInterceptor_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ApiErrorInterceptor)(i0.ɵɵinject(i1.AppMessageFactory), i0.ɵɵinject(i2.ErrorHandlerService), i0.ɵɵinject(i0.Injector));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: ApiErrorInterceptor,
        factory: ApiErrorInterceptor.ɵfac
      });
    }
  }
  return ApiErrorInterceptor;
})();